<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $tc('messages.gamification_sets', 2),
                        href: meta.links.set_index,
                    },
                    {
                        name: gamificationSet.breadcrumb_title,
                        href: meta.links.set_show,
                    },
                    {
                        name: $tc('messages.gamification_items', 2),
                        href: meta.links.index,
                    },
                    {
                        name: gamificationItem.name,
                        href: null,
                    },
                ]"
            />
        </template>

        <div>
            <NavLinks :links="meta.navGroupLinks" />
        </div>

        <div>
            <TitleFieldsFormSection>
                <template v-slot:title>
                    <div>
                        {{ $t('messages.information') }}
                    </div>
                    <div>
                        <img :src="gamificationItem.image_path" alt="" class="h-40" />
                    </div>
                </template>
                <div class="md:grid md:grid-cols-12 md:gap-6">
                    <div class="sm:col-span-8">
                        <div class="mt-1">
                            <span>
                                {{ gamificationItem.name }}
                            </span>
                        </div>
                    </div>

                    <div class="sm:col-span-12">
                        <div class="mt-1">
                            <p>{{ gamificationItem.description }}</p>
                        </div>
                    </div>
                </div>
            </TitleFieldsFormSection>
        </div>

        <div>
            <div class="md:col-span-2">
                <label for="can_take_student" class="block text-sm font-medium leading-5 text-gray-700">
                    {{ $t('messages.all') }}
                </label>
                <div class="mt-1">
                    <input
                        type="checkbox"
                        id="can_take_student"
                        name="can_take_student"
                        v-model="all"
                        class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                    />
                </div>
            </div>
        </div>

        <div class="m-3">
            <div class="md:grid md:grid-cols-3 lg:grid-cols-6 md:gap-6">
                <div
                    class="flex shrink-0 space-x-2 bg-white rounded-xl p-2"
                    v-for="student in filteredStudents"
                    :key="student.id"
                >
                    <img
                        :src="student.avatar_or_profile_photo"
                        alt=""
                        class="max-w-none h-16 w-16 rounded-full ring-2 ring-white"
                    />
                    <div class="flex flex-col">
                        <div>
                            {{ student.name_or_nickname }}
                        </div>
                        <div>
                            {{ student.student_items_new_count }} /
                            {{ student.student_items_count }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import TitleFieldsFormSection from '@/components/TitleFieldsFormSection.vue';
import NavLinks from '@/components/NavLinks.vue';

export default {
    components: {
        PanelPage,
        TitleFieldsFormSection,
        NavLinks,
    },
    layout: Layout,
    name: 'Show',
    props: ['teacher', 'meta', 'options', 'gamificationItem', 'gamificationSet'],
    data() {
        return {
            all: true,
        };
    },
    methods: {},
    computed: {
        filteredStudents: function () {
            let students = this.gamificationItem.students;
            if (!this.all) {
                students = students.filter((s) => !!s.student_items_new_count);
            }
            return students;
        },
    },
};
</script>
